'use strict';

const $ = require('jquery');
const _ = require('lodash');
const nunjucks = require('nunjucks');
const events = require('events');

class Controller extends events.EventEmitter {
	constructor(options) {
		super();
		this._options = Object.assign({}, ...arguments);
		this._template = undefined;
		this._container = undefined;
		_.bindAll(this, 'render', 'update');
	}

	get options() {
		return this._options;
	}

	get template() {
		return this._template || this._options.template;
	}

	get container() {
		return this._container || this._options.container;
	}

	get $container() {
		return this.$;
	}

	get $() {
		if (!this._$) {
			this._$ = $(this.container);
		}
		return this._$;
	}

	getRenderOptions(options) {
		return Object.assign({template: this.template}, this.options, options);
	}

	initContainer(options) {
		if (!options.container && this.container) {
			// Do nothing
			return options;
		}

		let c = options.container;
		this._$ = undefined;
		if (_.isString(c)) {
			this._container = document.querySelector(c);
		} else if (_.isElement(c)) {
			this._container = c;
		} else if (c instanceof $) {
			this._container = c[0];
		} else {
			console.error('Invalid container', c);
			throw TypeError('Invalid container');
		}
		return options;
	}

	renderTemplate(options) {
		let template = options.template;
		let container = this.container;
		if (!container) {
			throw new Error('Container not initialised or not found');
		}
		if (template instanceof nunjucks.Template) {
			this.container.innerHTML = template.render(options);
		} else if (_.isFunction(template)) {
			this.container.innerHTML = template(options);
		} else if (_.isString(template)) {
			this.container.innerHTML = nunjucks.renderString(template, options);
		}
	}

	draw(options) {
		this.renderTemplate(options);
		return options;
	}

	redraw(options) {
		return this.draw(options);
	}

	/**
	 * Basic render chain.
	 *
	 * Consists of 3 stages:
	 * - Prepare render options (call getRenderOptions method)
	 * - Find and initialise container (call intiContainer method)
	 * - Create DOM and cache needed selectors (call draw method)
	 *
	 * You can extend this chain by overriding any of chain stages
	 * or implementing additional stages in super's callback.
	 *
	 * @param options
	 * @returns {Promise<Object>}
	 */
	render(options) {
		let self = this;
		return Promise.resolve()
			.then(function () {
				return self.getRenderOptions(options);
			})
			.then(function (options) {
				return self.initContainer(options);
			})
			.then(function (options) {
				return self.draw(options);
			});
	}

	update(options) {
		let self = this;
		return Promise.resolve()
			.then(function () {
				return self.getRenderOptions(options);
			})
			.then(function (options) {
				return self.initContainer(options);
			})
			.then(function (options) {
				return self.redraw(options);
			});
	}

	destroy() {
		this.container.innerHTML = null;
	}
}

module.exports = Controller;